"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createPerformanceObserver = require("../utilities/createPerformanceObserver");

var _performance = require("../utilities/performance");

var _median = _interopRequireDefault(require("../utilities/median"));

var _getFirstContentfulPaint = _interopRequireDefault(require("../utilities/getFirstContentfulPaint"));

function isLongTask(entry) {
  return entry.entryType === _performance.EntryType.LONG_TASK;
}
/**
 * A plugin responsible for measuring long running tasks exposed by the
 * [Long Tasks API][1] - from navigation start until the page is loaded.
 *
 * This plugin adds the following parameters to the beacon:
 *
 * - `firstCpuIdle`: measures when the page is no longer janky. Specifically,
 *   it is the first span of 5 seconds where the browser main thread is never
 *   blocked for more than 50ms after First Contentful Paint.
 *
 * - `longestLongTask`: measures the longest long task that occured before
 *   the page loaded.
 *
 * - `medianLongTask`: measures the median long task.
 *
 * - `numberOfLongTasks`: measures the total number of individual JavaScript
 *   long tasks.
 *
 * - `totalLongTask`: measures the total time of all your JavaScript tasks over
 *   50ms added together.
 *
 * [1]: https://w3c.github.io/longtasks
 */


var createLongTaskPlugin = function createLongTaskPlugin() {
  return function (_ref) {
    var addVariable = _ref.addVariable,
        sendBeacon = _ref.sendBeacon;
    var entriesByName = {};
    var observer = null;

    try {
      observer = (0, _createPerformanceObserver.createPerformanceObserver)(_performance.EntryType.LONG_TASK, function (entry) {
        if (isLongTask(entry)) {
          var duration = Math.round(entry.duration);
          entry.attribution.forEach(function (attribution) {
            var key = attribution.name;
            if (entriesByName[key] == null) entriesByName[key] = [];
            entriesByName[key].push({
              startTime: Math.round(entry.startTime),
              duration: duration
            });
          });
        }
      });
    } catch (error) {// Do nothing.
    }

    return {
      pageDidLoad: function pageDidLoad() {
        if (observer != null) {
          var _entriesByName$key;

          // observer.takeRecords().forEach(performanceEntryHandler);
          observer.disconnect();
          var firstContentfulPaint = (0, _getFirstContentfulPaint.default)();
          var key = 'script' in entriesByName ? 'script' : 'unknown';
          var longTasks = (_entriesByName$key = entriesByName[key]) !== null && _entriesByName$key !== void 0 ? _entriesByName$key : [];
          var longTaskDurations = [];
          var totalLongTasks = 0;
          var longestLongTask = 0;
          var firstCpuIdle = firstContentfulPaint;

          for (var i = 0; i < longTasks.length; i += 1) {
            var _longTasks$i = longTasks[i],
                startTime = _longTasks$i.startTime,
                duration = _longTasks$i.duration;
            totalLongTasks += duration;
            longestLongTask = Math.max(longestLongTask, duration);
            longTaskDurations.push(duration);

            if (firstCpuIdle != null && firstCpuIdle < startTime) {
              if (startTime - firstCpuIdle < 5000) {
                firstCpuIdle = startTime + duration;
              }
            }
          }

          addVariable('longestLongTask', longestLongTask, true);
          addVariable('totalLongTasks', totalLongTasks, true);
          addVariable('numberOfLongTasks', longTasks.length, true);
          addVariable('medianLongTask', (0, _median.default)(longTaskDurations), true);

          if (firstCpuIdle != null) {
            addVariable('firstCpuIdle', firstCpuIdle, true);
          }

          sendBeacon();
        }
      }
    };
  };
};

var _default = createLongTaskPlugin;
exports.default = _default;